export enum ColumnsFilledOrdersEnum {
	tickerCompany = 'tickerCompany',
	operation = 'operation',
	quantity = 'quantity',
	sum = 'sum',
	profitability = 'profitability',
	dateTime = 'dateTime',
}
